import {
  Button,
  ClickAwayListener,
  FormControl,
  Grow,
  makeStyles,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Select,
} from "@material-ui/core";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import PropTypes from "prop-types";
import * as React from "react";
import { useContext, useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { LocalContext } from "../../../LocalProvider.js";
import LoginPage from "../../../pages/Login.page";
import { moveCartItemsToCartAction } from "../../../store/actions/cart.actions.js";
import {
  clearCartItemsDataAction,
  smartGetCartData
} from "../../../store/actions/cartItems.actions";
import { changeLanguageAction } from "../../../store/actions/language.action.js";
import {
  clearArchiveDataAction,
  clearReduxDataAction,
  fetchGetCheckSupervisor,
  fetchGetNavigation,
  fetchLogout,
  getCustomerArchiveStatus,
  setSoldToNumberAction
} from "../../../store/actions/navItems.actions";
import {
  getCartCountSelector,
  getCartOrderTypeSelector
} from "../../../store/selectors/cartItems.selector";
import {
  allHeaderData,
  getAssociatedCustomers,
  getChangePasswordRequired,
  getCustomerArchiveData,
  getHeaderNavData,
  getHeaderToken,
  getUserType,
  isAuthenticated,
} from "../../../store/selectors/navItems.selector";
import { colors, mediaQueries } from "../../../styles/variables";
import { apiHeaderWithSiteId, getEnv } from "../../../utils/urls";
import ProfileDialog from "../../common/ProfileDialog";
import AlertDialog from "../AlertDialog";
import {
  getSelectedAssociatedCustomer,
  getSelectedAssociatedCustomerCreditAmt,
  getSelectedAssociatedCustomerSapId,
  getSelectedAssociatedCustomerType,
  getDefaultRoutes,
  getUserId
} from "../helper/helper";
import { useAppD } from "../../appDynamics/useAppD";

const RightNav = ({ isOpen, navData }) => {
  const classes = useStyles();
  const [username, setUsername] = useState("");
  const [profileValue, setProfileValue] = useState(
    getSelectedAssociatedCustomerType() || null
  );
  const [navigationData, setNavigationData] = useState([]);
  const [openSignIn, setOpenSignIn] = useState(false);
  const [isCheckSupervisorCall, setIsCheckSupervisorCall] = useState(false);
  const [openMenus, setOpenMenus] = useState({});
  const [openOnTouch, setOpenOnTouch] = useState(false);
  const [selectedLink, setSelectedLink] = useState(null);
  const [selectedId, setSelectedId] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [customerArchiveAlert, setCustomerArchiveAlert] = useState(false);
  const [customerArchiveAlertMessages, setCustomerArchiveAlertMessages] = useState(false);
  const [customerArchiveCurrentMessage, setCustomerArchiveCurrentMessage] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [hoverTimeouts, setHoverTimeouts] = useState({});
  const changePasswordRequired = useSelector(getChangePasswordRequired);
  const [language, setLanguage] = React.useState(
    localStorage.getItem("language")
  );
  const { translate } = useContext(LocalContext);

  const [profileDialogOpen, setProfileDialogOpen] = useState(false);
  const token = useSelector(getHeaderToken);
  const isAuth = useSelector(isAuthenticated);
  const associatedCustomers = useSelector(getAssociatedCustomers);
  const userTypeData = useSelector(getUserType);
  const cartCount = useSelector(getCartCountSelector);
  const customerArchiveData = useSelector(getCustomerArchiveData);
  const orderTypeCart = useSelector(getCartOrderTypeSelector);

  const { setAppDUserData, setAppDPageName } = useAppD();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const anchorRefs = useRef({});
  const headerData = useSelector(allHeaderData);
  const isUserAuth = headerData;
  // Use Redux selector to get latest navData instead of relying on prop
  const navDataFromRedux = useSelector(getHeaderNavData);
  // Use Redux data if available, otherwise fall back to prop
  const currentNavData = navDataFromRedux || navData;
  const [creditAmount, setCreditAmount] = useState(
    getSelectedAssociatedCustomerCreditAmt()
  );
  const defaultRoutes = getDefaultRoutes() || [];
  var selectedCustomerCreditAmt = localStorage.getItem("selectedCustomerCreditAmt");

  useEffect(() => {
    setAppDPageName(location.pathname);
    setAppDUserData({
      userId: getUserId(),
      customerId: getSelectedAssociatedCustomer(),
      userType: userTypeData
    });
    if (location.pathname.includes("products")) {
      setSelectedMenu(1);
    } else if (
      location.pathname.includes("order") ||
      location.pathname.includes("buy")
    ) {
      setSelectedMenu(2);
    } else if(location.pathname.includes("project")) {
      setSelectedMenu(3);
    }
  }, [location.pathname]);

  const getArchieveMessages = (archiveData) => {
    const tempMessages = [];
  
    if(archiveData?.archiveBox?.hasOwnProperty("msg")) {
      tempMessages.push({'header': 'archiveBox', 'msg': archiveData?.archiveBox?.msg });
    }

    if(archiveData?.contract?.hasOwnProperty("msg")) {
      tempMessages.push({'header': 'contract', 'msg': archiveData?.contract?.msg });
    }

    if(archiveData?.estatement?.hasOwnProperty("msg")) {
      tempMessages.push({'header': 'estatement', 'msg': archiveData?.estatement?.msg });
    }

    if(archiveData?.idtPromotionMsg?.hasOwnProperty("msg")) {
      tempMessages.push({'header': 'idtPromotionMsg', 'msg': archiveData?.idtPromotionMsg?.msg });
    }
    setCustomerArchiveAlertMessages(tempMessages);
    if(tempMessages?.length > 0) {
      setCustomerArchiveAlert(true);
    }
  }

  // Show Next Archive Message In Separate Popup
  const showNextArchieveMessage = () => {
    if(customerArchiveAlertMessages?.length > 0) {
      const nextMessage = customerArchiveAlertMessages.shift();
      setCustomerArchiveCurrentMessage(nextMessage);
      setCustomerArchiveAlertMessages([...customerArchiveAlertMessages]);
    } else {
      setCustomerArchiveCurrentMessage(null);
      handleCloseArchiveAlert();
    }
  }

  // Initially Show First Archieve Message
  useEffect(() => {
    if(customerArchiveAlertMessages && customerArchiveAlert && customerArchiveCurrentMessage === null) {
      showNextArchieveMessage();
    }
  }, [customerArchiveAlertMessages, customerArchiveCurrentMessage, customerArchiveAlert])

  useEffect(() => {
    if(isAuth && customerArchiveData) {
     getArchieveMessages(customerArchiveData);
    }
  }, [token, isAuth, customerArchiveData]);

  useEffect(() => {
    selectedCustomerCreditAmt && setCreditAmount(getSelectedAssociatedCustomerCreditAmt());
  }, [selectedCustomerCreditAmt]);

  // Handle mouse enter for dropdown menus
  const handleMouseEnter = useCallback((menuKey) => {
    // Clear any existing timeout for this menu
    if (hoverTimeouts[menuKey]) {
      clearTimeout(hoverTimeouts[menuKey]);
    }

    // Open the menu immediately
    setOpenMenus(prev => ({ ...prev, [menuKey]: true }));
  }, [hoverTimeouts]);

  // Handle mouse leave for dropdown menus
  const handleMouseLeave = useCallback((menuKey) => {
    // Set a timeout to close the menu after a short delay
    const timeoutId = setTimeout(() => {
      setOpenMenus(prev => ({ ...prev, [menuKey]: false }));
    }, 100); // 150ms delay to allow smooth navigation

    setHoverTimeouts(prev => ({ ...prev, [menuKey]: timeoutId }));
  }, []);

  // Clean up timeouts on unmount
  useEffect(() => {
    return () => {
      Object.values(hoverTimeouts).forEach(timeoutId => {
        if (timeoutId) clearTimeout(timeoutId);
      });
    };
  }, [hoverTimeouts]);

  const onChangeUsername = () => {
    // if (event.target.value !== "Change Customer") {
    //   setUsername(event.target.value);
    // }
  };

  const onClickMenu = (event) => {
    event.preventDefault();
  };

  //Mobile Toggle menu header when click
  const onTouchMenuToggle = (key) => {
    setSelectedLink(key);
    setOpenOnTouch((openOnTouch) => !openOnTouch);
  };

  const onClickSubMenu = (event) => {
    const key = event.currentTarget.getAttribute("id");
    if (key.includes("shop")) {
      setSelectedMenu(1);
    }
    if (key.includes("order")) {
      setSelectedMenu(2);
    }
    if (key.includes("project")) {
      setSelectedMenu(3);
    }
  };

  const handleCloseMenu = (event, menuKey) => {
    const anchorEl = anchorRefs.current[menuKey];
    if (anchorEl && anchorEl.contains(event.target)) {
      return;
    }
    setOpenMenus(prev => ({ ...prev, [menuKey]: false }));
  };

  function handleListKeyDown(event, menuKey) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenMenus(prev => ({ ...prev, [menuKey]: false }));
    }
  }

  const onClickSignIn = () => {
    let toggle = openSignIn ? false : true;
    setOpenSignIn(toggle);
  };

  const handleCloseSignIn = () => {
    setOpenSignIn(false);
  };

  const handleLogout = () => {
    dispatch(fetchLogout(token));
  };

  const handleChangeCustomer = () => {
    setCustomerArchiveAlert(false);
    var selectedCustomerID = getSelectedAssociatedCustomer();
    dispatch(fetchGetCheckSupervisor(token, isAuth)).then((data) => {
      const customers = data?.associatedCustomers || associatedCustomers;
      if (
        selectedCustomerID &&
        selectedCustomerID !== null &&
        customers &&
        customers.length > 1 &&
        profileDialogOpen === false
      ) {
        setOpenAlert(true);
      }
    });
  };

  const handleAgreeClick = () => {
    setOpenAlert(false);
    setProfileDialogOpen(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setProfileDialogOpen(false);
  };

  const handleCloseArchiveAlert = () => {
    if(customerArchiveAlertMessages?.length > 1) {
      setCustomerArchiveAlert(true);  
    } else {
      setCustomerArchiveAlert(false);
      if (associatedCustomers) {
        dispatch(clearReduxDataAction(token));
      }
      dispatch(clearArchiveDataAction(token));
      if (changePasswordRequired) {
        history.push("/change-password?changepwd=1");
      } else if(customerArchiveCurrentMessage.header.includes("idtPromotionMsg")) {
        history.push("/projectList");
      } else {
        history.push("/home");
      }
    }
  };

  const handleMyAccount = () => {
    history.push("/my-account");
  };

  const handleChangePassword = () => {
    history.push("/change-password?changepwd=1");
  };

  const handleChangeLanguageCN = async (event) => {
    const newLanguage = event.target.value;
    setLanguage(newLanguage);

    // Update localStorage first
    localStorage.setItem("language", newLanguage);
    
    // Update language in Redux - this will update all translations through LocalContext
    dispatch(changeLanguageAction(newLanguage));
    
    // Fetch navigation to get translated menu items and wait for completion
    await dispatch(fetchGetNavigation());
    
    // Force update navigation data after language change
    const menuData = leftNavigation(userTypeData);
    setNavigationData(menuData);
  };

  const leftNavigation = useCallback((userTypeData) => {
    // If no currentNavData available, return empty array
    if (!currentNavData || !currentNavData.leftNavigation) {
      return [];
    }
    
    // For anonymous users (userTypeData is null), return the base leftNavigation
    if (!userTypeData || !isAuth) {
      return currentNavData.leftNavigation;
    }
    
    // For authenticated users, return specific navigation based on userType
    switch (userTypeData) {
      case "Payer":
        return currentNavData.leftNavigation.Payer || currentNavData.leftNavigation;

      case "MT":
        return currentNavData.leftNavigation.MT || currentNavData.leftNavigation;

      case "Sold_To_Party":
        return currentNavData.leftNavigation.Sold_To_Party || currentNavData.leftNavigation;
      
      case "BNCMulti":
        return currentNavData.leftNavigation.BNCMulti || currentNavData.leftNavigation;

      case "Profile":
        if (profileValue === "Payer") {
          return currentNavData.leftNavigation.Payer || currentNavData.leftNavigation;
        }
        if (profileValue === "Sold_To_Party") {
          return currentNavData.leftNavigation.Sold_To_Party || currentNavData.leftNavigation;
        }
        if (profileValue === "MT") {
          return currentNavData.leftNavigation.MT || currentNavData.leftNavigation;
        }
        if (profileValue === "Profile") {
          return currentNavData.leftNavigation.Profile || currentNavData.leftNavigation;
        }
        if (profileValue === "BNCMulti") {
          return currentNavData.leftNavigation.BNCMulti || currentNavData.leftNavigation;
        }
        break;

      default:
        return currentNavData.leftNavigation;
    }
  }, [currentNavData, profileValue, isAuth]);

  useEffect(() => {
    const menuData = leftNavigation(userTypeData);
    
    // Skip route validation if navigation data is not yet loaded or is not an array
    if (!menuData || !Array.isArray(menuData) || menuData.length === 0) {
      return;
    }
    
    // Filter out routes accessible to the user based on the menu data
    const allowedRoutes = menuData?.flatMap(singleNav => singleNav.subMenu || []).filter(singleSubMenu => location.pathname === `/${singleSubMenu.key}`) || [];

    const mergedRoutes = [...allowedRoutes, ...defaultRoutes];
    // If there are allowed routes for the current location, update the navigation data
    if (mergedRoutes?.length > 0 && mergedRoutes?.some((item) => location.pathname.includes(item.key))) {
      setNavigationData(menuData);
    } else {
      // If there are no allowed routes, redirect the user to a default route
      history.push("/home")
    }
  }, [userTypeData, navData, leftNavigation, location.pathname, currentNavData]);

  const getAssociatedCustomersOfProfile = useCallback(() => {
    var selectedCustomerID = getSelectedAssociatedCustomer();
    var selectedCustomerType = getSelectedAssociatedCustomerType();
    if (!associatedCustomers && !isCheckSupervisorCall) {
      dispatch(fetchGetCheckSupervisor());
      setIsCheckSupervisorCall(true);
    }
    if (associatedCustomers && associatedCustomers.length === 1) {
      localStorage.setItem("selectedCustomerID", associatedCustomers[0].id);
      localStorage.setItem("selectedCustomerType", associatedCustomers[0].type);
      setProfileValue(associatedCustomers[0].type);
      localStorage.setItem(
        "selectedCustomerSapId",
        associatedCustomers[0].sapCode
      );
      localStorage.setItem(
        "selectedCustomerCreditAmt",
        associatedCustomers[0].creditBalance
      );
    } else if (
      associatedCustomers &&
      associatedCustomers.length > 1 &&
      selectedId === "" &&
      profileDialogOpen === false &&
      (selectedCustomerID === undefined || selectedCustomerID === null) &&
      (selectedCustomerType === undefined || selectedCustomerType === null)
    ) {
      setProfileDialogOpen(true);
    }
  });

  useEffect(() => {
    if(userTypeData === "Profile") {
      getAssociatedCustomersOfProfile();
    }
  }, [userTypeData, getAssociatedCustomersOfProfile]);

  useEffect(() => {
    const menuData = leftNavigation(userTypeData);
    setNavigationData(menuData);
  }, [profileValue, leftNavigation, userTypeData, currentNavData, language]);

  const handlecloseprofile = (selectedCustomerId) => {
    if (selectedCustomerId && selectedCustomerId !== null) {
      setSelectedId(selectedCustomerId);
      setProfileValue(getSelectedAssociatedCustomerType());
    }
    setProfileDialogOpen(false);
    dispatch(clearCartItemsDataAction(token)).then(() => {
      dispatch(fetchGetNavigation());
      // TO GET THE CART DATA FROM GET CART ITEM COUNT API
      dispatch(smartGetCartData(false, token)).then(() => {
        dispatch(moveCartItemsToCartAction(orderTypeCart));
      });
      dispatch(getCustomerArchiveStatus(token)).then((data) => {
        if (isAuth && data !== undefined) {
          getArchieveMessages(data);
        } else {
          dispatch(clearReduxDataAction(token));
          if (changePasswordRequired) {
            history.push("/change-password?changepwd=1");
          } else {
            history.push("/home");
          }
        }
      });
      // Update Redux soldToNumber for the new customer so Header.jsx
      // useEffect fires exactly once and fetches the correct TT status.
      const newSoldToId = userTypeData === "Profile"
        ? (getSelectedAssociatedCustomerSapId() || getSelectedAssociatedCustomer())
        : getSelectedAssociatedCustomer();
      if (newSoldToId) {
        dispatch(setSoldToNumberAction(newSoldToId));
      }
    });
  };

  return (    
    <MenuHolder open={isOpen}>
      {/* ALERT POPUP FOR CHANGE CUSTOMER */}
      {openAlert && (
        <AlertDialog
          open={openAlert}
          handleClose={() => handleCloseAlert()}
          handleAgreeClick={() => handleAgreeClick()}
          headerMessage={translate(
            "Are you sure that you would like to change the customer?"
          )}
          contentMessage={translate(
            "Your current cart will be cleared, You won't be able to undo the changes done!"
          )}
          yesBtnLabel={translate("Continue")}
          noBtnLabel={translate("Cancel")}
        />
      )}

      {/* If associatedCustomer are more than one */}
      {profileDialogOpen && (
        <ProfileDialog
          open={profileDialogOpen}
          handlecloseprofile={(selectedCustomerId) => handlecloseprofile(selectedCustomerId)}
          title={translate("Choose a Customer")}
          dropdowndata={associatedCustomers}
        />
      )}

      {customerArchiveCurrentMessage && (
        <AlertDialog
          open={customerArchiveAlert}
          handleClose={() => showNextArchieveMessage()}
          contentMessage={
            <div>
              {customerArchiveCurrentMessage?.msg && (
                <p
                  dangerouslySetInnerHTML={{
                    __html: customerArchiveCurrentMessage?.msg,
                  }}
                ></p>
              )}
            </div>
          }
          noBtnLabel={translate("StatusOk")}
        />
      )}

      {!changePasswordRequired && (
        <LeftItem>
          {navigationData &&
            navigationData?.map((headerDataAPI, key) => (
              <div key={key}>
                {headerDataAPI?.subMenu === undefined && (
                  <>
                    <li className={classes.homeLink}>
                      <HeaderLink to={"/" + headerDataAPI?.key} exact>
                        <strong>{translate(headerDataAPI?.link)}</strong>
                      </HeaderLink>
                    </li>
                  </>
                )}
                {headerDataAPI?.subMenu !== undefined && (
                  <>
                    <li
                      onMouseEnter={() => handleMouseEnter(key)}
                      onMouseLeave={() => handleMouseLeave(key)}
                    >
                      <ButtonSty
                        selecttab={selectedMenu == key ? "test" : ""}
                        ref={(el) => (anchorRefs.current[key] = el)}
                        aria-controls={openMenus[key] ? `menu-list-grow-${key}` : undefined}
                        aria-haspopup="true"
                        onClick={onClickMenu}
                        onTouchStart={() => onTouchMenuToggle(key)}
                        to={"/" + headerDataAPI?.key}
                      >
                        <strong>{translate(headerDataAPI?.link)}</strong>
                      </ButtonSty>
                      <PopperItem
                        open={openMenus[key] || false}
                        className={
                          selectedLink == key && openOnTouch
                            ? classes.mobilePopper
                            : ""
                        }
                        anchorEl={anchorRefs.current[key]}
                        role={undefined}
                        transition
                        disablePortal
                        onMouseEnter={() => handleMouseEnter(key)}
                        onMouseLeave={() => handleMouseLeave(key)}
                      >
                        {({ TransitionProps, placement }) => (
                          <Grow
                            {...TransitionProps}
                            style={{
                              transformOrigin:
                                placement === "bottom"
                                  ? "center top"
                                  : "center bottom",
                              padding: "0 5px 0 5px",
                            }}
                          >
                            <Paper>
                              <ClickAwayListener onClickAway={(event) => handleCloseMenu(event, key)}>
                                <MenuList
                                  autoFocusItem={openMenus[key] || false}
                                  id={`menu-list-grow-${key}`}
                                  onKeyDown={(event) => handleListKeyDown(event, key)}
                                >
                                  {headerDataAPI?.subMenu?.map(
                                    (userdata, subKey) => (
                                      <SubHeaderLink
                                        to={"/" + userdata.key}
                                        key={subKey}
                                        id={headerDataAPI?.key + "-" + subKey}
                                        onClick={onClickSubMenu}
                                      >
                                        {translate(userdata.link)}
                                      </SubHeaderLink>
                                    )
                                  )}
                                </MenuList>
                              </ClickAwayListener>
                            </Paper>
                          </Grow>
                        )}
                      </PopperItem>
                    </li>
                  </>
                )}
              </div>
            ))}
        </LeftItem>
      )}

      {!changePasswordRequired && (
        <RightItem>
          {/* Bestsign for China */}
          {getEnv().siteId === "1" &&
            currentNavData && currentNavData.middleNavigation && currentNavData.middleNavigation.map((userdata, key) => (
              <div className="bestsign" key={key}>
                <span
                  key={key}
                  dangerouslySetInnerHTML={{
                    __html: translate(userdata.link),
                  }}
                />
              </div>
            ))}
          {/* Language Selector for China */}
          {getEnv().siteId === "1" && (
            <FormControl className={classes.formControl}>
              <Select
                value={language}
                onChange={handleChangeLanguageCN}
                displayEmpty
                className={classes.marginTopUserName}
                inputProps={{
                  id: "language",
                  name: "language"
                }}
              >
                <MenuItem className={classes.menuItemStyle} value="zh">
                  <strong className={classes.loggedInItemsLabel}>中文</strong>
                </MenuItem>
                <MenuItem className={classes.menuItemStyle} value="en">
                  <strong className={classes.loggedInItemsLabel}>
                    English
                  </strong>
                </MenuItem>
              </Select>
            </FormControl>
          )}

          {!isUserAuth.isAuth && (
            <>
              <HeaderNavItem>
                <HeaderButton onClick={() => onClickSignIn()}>
                  {currentNavData?.rightNavigation?.map((userdata, key) => (
                    <strong key={key}>{translate(userdata.link)}</strong>
                  ))}
                </HeaderButton>
              </HeaderNavItem>
            </>
          )}

          {openSignIn && <LoginPage handleCloseSignIn={handleCloseSignIn} />}
          {isUserAuth.isAuth === true && (
            <>
              <div className={classes.creditAmount}>
                {translate("Credit Amount")} :{" "}
                <span className={classes.creditAmountText}>
                  {getEnv().currency}
                  {creditAmount}
                </span>
              </div>
              <FormControl className={classes.formControl}>
                <Select
                  value={username}
                  onChange={onChangeUsername}
                  displayEmpty
                  className={classes.marginTopUserName}
                  inputProps={{ 
                    "aria-label": "Without label",
                    id: "username",
                    name: "username"
                  }}
                >
                  <MenuItem value="" disabled className={classes.menuItemStyle}>
                    <strong className={classes.loggedInItemsLabel}>
                      {currentNavData?.userName}
                    </strong>
                  </MenuItem>
                  {currentNavData?.rightNavigation?.map((userdata, key) => (
                    <MenuItem
                      key={key}
                      value={userdata.link}
                      className={classes.menuItemStyle}
                    >
                      {(userdata.key === "Logout" ||
                        userdata.key === "logout") && (
                        <div
                          className={classes.loggedInItems}
                          onClick={() => handleLogout()}
                        >
                          {userdata.link}
                        </div>
                      )}

                      {(userdata.key === "Change Password" ||
                        userdata.key === "change-password") && (
                        <div
                          className={classes.loggedInItems}
                          onClick={() => handleChangePassword()}
                        >
                          {userdata.link}
                        </div>
                      )}

                      {(userdata.key === "My Account" ||
                        userdata.key === "my-account") && (
                        <div
                          className={classes.loggedInItems}
                          onClick={() => handleMyAccount()}
                        >
                          {userdata.link}
                        </div>
                      )}

                      {(userdata.key === "Change Customer" ||
                        userdata.key === "change-customer") && (
                        <div
                          className={classes.loggedInItems}
                          onClick={() => handleChangeCustomer()}
                        >
                          {userdata.link}
                        </div>
                      )}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <HeaderNavItemCart>
                <HeaderLink
                  to="/cart-preview"
                  className={location.pathname === "/cart-preview" ? "active" : ""}
                >
                  <ShoppingCartIconStyle />
                  <DivCart>
                    <SpanCart>
                      {cartCount}
                    </SpanCart>
                  </DivCart>
                </HeaderLink>
              </HeaderNavItemCart>
            </>
          )}
        </RightItem>
      )}
    </MenuHolder>
  );
};

const useStyles = makeStyles(
  (theme) => ({
    paper: {
      "& li": {
        padding: "0 10px",
      },
    },
    formControl: {
      margin: theme.spacing(0.5),
      minWidth: 90,
      "& > div": {
        backgroundColor: "#fafafa",
        "&::before": {
          borderBottom: "none",
          "&::focus": {
            backgroundColor: colors.red,
          },
        },
        "&::after": {
          borderBottom: "none",
        },
      },
    },
    menuItemStyle: {
      padding: 0,
    },
    loggedInItems: {
      color: "grey",
      textDecoration: "none",
      width: "100%",
      padding: "0.5rem",
      "&:hover": {
        color: "black",
      },
      "&:active": {
        color: "black",
      },
      "&:focus": {
        color: "black",
      },
    },
    loggedInItemsLabel: {
      width: "100%",
      padding: "0.5rem",
    },
    marginTopUserName: {
      marginTop: "1.5rem",
      fontSize: "1.25rem",
      [theme.breakpoints.down("xl")]: {
        fontSize: "1rem",
      },
      "@media (max-width: 1366px)": {
        fontSize: "0.85rem",
        marginTop: "1.6rem",
      },
      [theme.breakpoints.down(768)]: {
        fontSize: "1.25rem",
      },
      "& svg": {
        fontSize: "2.1rem",
        top: "calc(50% - 15px)",
      },
    },
    select: {
      "& option": {
        backgroundColor: "red",
        color: "red",
      },
    },
    [theme.breakpoints.down(768)]: {
      marginTopUserName: {
        color: colors.blue,
      },
      formControl: {
        marginLeft: theme.spacing(2),
      },
    },
    creditAmount: {
      marginTop: "1.75rem",
      // marginRight: "0.5rem",
      backgroundColor: "#F1F3F4",
      borderRadius: "1rem",
      fontSize: "0.85rem",
      fontWeight: "bold",
      lineHeight: "1rem",
      maxHeight: "30px",
      padding: "0.5rem",
      "@media (max-width: 1366px)": {},
      "@media (max-width: 950px)": {
        display: "none",
      },
    },
    creditAmountText: {
      color: "#11D301",
      fontWeight: "normal",
    },
    homeLink: {
      paddingRight: "0rem !important",
    },
    mobilePopper: {
      [theme.breakpoints.down("sm")]: {
        display: "block !important",
      },
    },
  }),
  { name: "MuiMenu" }
);

const LeftItem = styled.ul`
  list-style: none;
  display: flex;
  margin: 0;
  padding: 1.25rem 0 0 0;
  flex-flow: row nowrap;
  li {
    padding: 22px 10px;
    position: relative;
    @media ${mediaQueries.belowiPad} {
      display: inline-block;
    }
  }
  @media (max-width: 768px) {
    display: block;
    li {
      padding: 7px;
    }
  }
`;

const RightItem = styled.ul`
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0.2rem 0;
  flex-flow: row nowrap;
  font-size: 1rem;
  li {
    padding: 22px 7px;
  }
  & div.bestsign {
    padding: 2rem 2rem 0 2rem;
  }
  @media (max-width: 760px) {
    display: block;
    li {
      padding: 7px;
    }
  }
`;

const MenuHolder = styled.div`
  list-style: none;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: inherit;
  & > div {
    display: none;
  }
  li {
    padding: 1rem 1.3rem 0 2rem;
    font-size: 1.25rem;
    @media ${mediaQueries.belowContainer} {
      font-size: 1rem;
    }
    @media ${mediaQueries.belowContainerStandard} {
      font-size: 0.85rem;
    }
    @media (max-width: 768px) {
      font-size: 1.25rem;
    }
    & > div {
      & > div {
        border-radius: 0;
        box-shadow: none;
      }
    }
  }
  @media (max-width: 950px) {
    li {
      padding: 10px 14px;
    }
  }
  @media (max-width: 768px) {
    flex-flow: column nowrap;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
    position: ${({ open }) => (open ? "absolute" : "fixed")};
    top: 100;
    right: 0;
    height: auto;
    maxwidth: 100%;
    margin-top: 3.45rem;
    transition: transform 0.3s ease-in-out;
    background: ${colors.white};
    z-index: 1;
    li {
      padding: 10px 20px;
    }
  }
`;

const HeaderNavItem = styled.li`
  float: left;
  text-align: center;
  padding-top: 1.9rem !important;
  text-decoration: none;
  font-size: 18px;
  line-height: 25px;
  border-radius: 4px;
  @media (max-width: 768px) {
    float: none;
    padding: 0;
    text-align: left;
  }
`;

const HeaderNavItemCart = styled.li`
  float: left;
  text-align: center;
  padding: 12px;
  text-decoration: none;
  font-size: 18px;
  line-height: 25px;
  border-radius: 4px;
  @media (max-width: 768px) {
    float: none;
    padding: 0;
    text-align: left;
  }
`;

const HeaderLink = styled(NavLink)`
  color: ${colors.greyDark};
  text-decoration: none;
  position: relative;
  text-transform: capitalize;
  display: inline-block;
  font-size: 1.25rem;
  @media ${mediaQueries.belowContainer} {
    font-size: 1rem;
  }
  @media ${mediaQueries.belowContainerStandard} {
    font-size: 0.85rem;
  }
  &:hover {
    color: ${colors.greyDark};
  }
  &.active {
    border-bottom: 2px solid red;
    font-weight: bold;
  }
  @media (max-width: 768px) {
    color: ${colors.blue};
    font-size: 1.25rem;
  }
`;

const SubHeaderLink = styled(NavLink)`
  color: ${colors.greyDark};
  text-decoration: none;
  position: relative;
  text-transform: capitalize;
  display: block;
  font-size: 1.25rem;
  padding: 0.25rem 1rem 0.25rem 1.3rem;
  width: max-content;
  @media ${mediaQueries.belowContainer} {
    font-size: 0.85rem;
  }
  @media ${mediaQueries.belowContainerStandard} {
    font-size: 0.7rem;
  }
  &:hover {
    color: ${colors.lightGrey};
  }
  &.active {
    font-weight: bold;
  }
  @media (max-width: 768px) {
    color: ${colors.blue};
    font-size: 1.25rem;
  }
`;

const HeaderButton = styled(Button)`
  color: ${colors.greyDark};
  padding: 0px;
  text-transform: capitalize;
  font-size: 16px;
  &:hover {
    color: ${colors.greyDark};
    background-color: #fafafa;
  }
  @media (max-width: 768px) {
    color: ${colors.blue};
    font-size: 1.25rem;
  }
`;

const ButtonSty = styled(NavLink)`
  color: ${colors.greyDark};
  text-decoration: none;
  position: relative;
  border-bottom: ${(props) =>
    props.selecttab === "test" ? "2px solid red" : "none"};

  &:after {
    color: rgba(0, 0, 0, 0.54);
    content: url(/icons/arrowIcon.svg);
    position: absolute;
    top: calc(50% - 16px);
    font-size: 2.1rem;
    opacity: 0.55;
  }
  &:hover {
    @media ${mediaQueries.mobileAndAbove} {
      color: ${colors.lightGrey};
      &:after {
        transition: 0.9s;
        top: calc(50% - 16px);
        content: url(/icons/arrowIconUp.svg);
      }
    }
  }
  @media (max-width: 768px) {
    color: ${(props) => (props.hoverontouch ? colors.lightGrey : colors.blue)};
    font-size: 1.25rem;
    &:after {
      content: ${(props) =>
        props.hoverontouch ? "url(/icons/arrowIconUp.svg)" : ""};
    }
  }
`;
const PopperItem = styled(Popper)`
  z-index: 1;
  transform: none !important;
  top: 39px !important;
  left: 0 !important;
  width: auto;
  margin-left: 15px;
  @media (min-width: 1366px) {
    top: 38px !important;
  }
`;

const ShoppingCartIconStyle = styled(ShoppingCartIcon)`
  margin-top: 0.8rem;
  @media (max-width: 768px) {
    display: none;
  }
`;

const DivCart = styled.div`
  border-radius: 50%;
  display: inline-block;
  background: #ff4b4b;
  color: white;
  width: 25px;
  height: 25px;
  vertical-align: top;
  position: absolute;
  top: -6px;
  right: -14px;
  font-size: 0.8rem;
  @media (max-width: 768px) {
    display: none;
  }
`;

const SpanCart = styled.span`
  line-height: 25px;
  display: inline-block;
  color: white;
  vertical-align: top;
  text-align: center;
  font-size: 0.75rem;
`;

RightNav.defaultPropTypes = {};

RightNav.propTypes = {
  navData: PropTypes.object.isRequired,
};

export default RightNav;
